/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useReactForm } from "../react-hook/use-react-form";
import { IconRender } from "@/components/shared/Icon-render";
import { SelectWithSearch } from "@/components/form-input";
import { ExpressionInput } from "../user-input/expression-input";
import { useWatch } from "react-hook-form";
import { cn } from "@/lib/utils";
import { useEffect } from "react";
import { RequiredInput } from "@/components/shared/required-input";

type UserFormType = {
  formData: any;
  onOpenChange: (prop: any) => void;
  onFormSubmit: (prop: boolean) => Promise<void>;
  open: boolean;
  companyData: any;
  synonymList: any;
  domainList: any;
  loadingSynonym: any;
};
export const ReactForm = ({
  formData,
  onOpenChange,
  onFormSubmit,
  open,
  synonymList,
  domainList,
  loadingSynonym,
}: UserFormType) => {
  const { form, onSubmit, control } = useReactForm({
    formData,
    onOpenChange,
    onFormSubmit,
    open,
  });

  const domain_name = useWatch({
    control,
    name: "domain_name",
  });

  const isDisabled = synonymList.find(
    (item: any) => item.domain_id === domain_name
  );

  useEffect(() => {
    if (formData?.domain_name) {
      loadingSynonym(formData.domain_name as string);
    }
  }, [formData?.domain_name]);

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="grid grid-cols-2 gap-x-6 gap-y-5 px-6">
          <FormField
            control={form.control}
            name="domain_name"
            render={({ field }) => (
              <FormItem className="col-span-2">
                <FormLabel>
                  Synonym
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <SelectWithSearch
                    bindLabel="label"
                    bindValue="value"
                    options={domainList}
                    value={field.value}
                    onChange={(prop: string) => {
                      field.onChange(prop);
                      loadingSynonym(prop as string);
                    }}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* <FormField
            control={form.control}
            name="synonym_mapping"
            defaultValue=""
            render={({ field }) => (
              <FormItem>
                <FormLabel>Synonym mapping</FormLabel>
                <FormControl>
                  <SelectWithSearch
                    bindLabel="label"
                    bindValue="value"
                    options={domainList}
                    value={field.value}
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          /> */}
        </div>
        <div
          className={cn(
            "grid grid-cols-2 gap-x-6 gap-y-5 px-6 pt-5 pb-5 relative"
          )}
        >
          <FormField
            control={form.control}
            name="expression"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Expression
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <ExpressionInput
                    bindLabel="label"
                    bindValue="value"
                    options={synonymList}
                    value={field.value}
                    onChange={field.onChange}
                    isEnable={isDisabled ? false : true}
                  />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />
          <div className="flex">
            <span className="pr-4 pl-7 text-slate-600 flex items-center text-4xl translate-y-4"></span>
            <FormField
              control={form.control}
              name="result"
              render={({ field }) => (
                <FormItem className="pl-10 w-full h-full">
                  <FormLabel>
                    Result
                    <RequiredInput />
                  </FormLabel>
                  <div
                    className={cn(
                      "border p-4 rounded-md w-full h-[calc(100%_-_32px)]",
                      isDisabled ? "opacity-65 pointer-events-none" : ""
                    )}
                  >
                    <FormControl>
                      <SelectWithSearch
                        bindLabel="label"
                        bindValue="value"
                        options={synonymList}
                        value={field.value}
                        onChange={field.onChange}
                      />
                    </FormControl>
                    <FormMessage />
                  </div>
                </FormItem>
              )}
            />
          </div>
        </div>
        <hr className="mt-5" />
        <DialogFooter className="p-6 flex !justify-start">
          <Button
            type="submit"
            className="w-[120px]"
            disabled={form.formState.isSubmitting}
          >
            {form.formState.isSubmitting ? (
              <IconRender
                name="LoaderCircle"
                className="w-5 animate-spin text-white zoom-in-150"
              />
            ) : (
              "Save"
            )}
          </Button>
          <Button
            type="submit"
            onClick={() => onOpenChange(false)}
            variant={"outline"}
            className="w-[120px]"
          >
            Close
          </Button>
        </DialogFooter>
      </form>
    </Form>
  );
};
